const currencyFormatter = new Intl.NumberFormat('es-PE', {
  style: 'currency',
  currency: 'PEN',
  minimumFractionDigits: 2,
});

export function formatCurrency(value) {
  if (value === '' || value === null || value === undefined || Number.isNaN(Number(value))) {
    return '';
  }
  return currencyFormatter.format(Number(value));
}

export function todayIsoDate() {
  const now = new Date();
  const offsetMs = now.getTimezoneOffset() * 60_000;
  return new Date(now.getTime() - offsetMs).toISOString().slice(0, 10);
}

export function formatDate(iso) {
  if (!iso) return '';
  const [year, month, day] = iso.split('-');
  if (!year || !month || !day) return iso;
  return `${day}/${month}/${year}`;
}

const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export function monthName(monthIndex) {
  return MONTH_NAMES[monthIndex] ?? '';
}

export function formatMonthYear(year, monthIndex) {
  return `${monthName(monthIndex)} ${year}`;
}

export function monthRange(year, monthIndex) {
  const firstDay = new Date(Date.UTC(year, monthIndex, 1));
  const lastDay = new Date(Date.UTC(year, monthIndex + 1, 0));
  const toIso = (date) => date.toISOString().slice(0, 10);
  return { feDesde: toIso(firstDay), feHasta: toIso(lastDay) };
}

export function currentMonthRef() {
  const now = new Date();
  return { year: now.getUTCFullYear(), month: now.getUTCMonth() };
}